import React from 'react';

// eslint-disable-next-line react/prop-types
const Header = ({ onToggleLinksPage, linksPageIsActive }) => {
    const componentClass = 'header';

    return <nav className={componentClass}>
        <div className={`${componentClass}__menu-btn`} onClick={onToggleLinksPage}>
            {linksPageIsActive ? <i className="ion-md-close" /> : <i className="ion-logo-usd" /> }
        </div>
    </nav>;
};

export default Header;
